import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { KIT_ENABLED } from './kitEnabled';

const KitPage = KIT_ENABLED ? lazy(() => import('./KitPage')) : null;

/** `/__kit`: fuera de la carcasa, para ver cada componente aislado (y auditarlo con axe). */
export const kitRoutes: RouteObject[] =
  KitPage === null
    ? []
    : [
        {
          path: '__kit',
          element: (
            <Suspense fallback={null}>
              <KitPage />
            </Suspense>
          ),
        },
      ];
